import { SweepButton } from "@softmax/design-system";
import { sectionLabel, bodyText } from "./profile-styles";

export function ProfileSignOut({
  pending,
  error,
  onSignOut,
}: {
  pending: boolean;
  error: string | undefined;
  onSignOut(): void;
}) {
  return (
    <div className="flex flex-col gap-[48px] pb-[48px] md:flex-row md:gap-[64px]">
      <section
        aria-labelledby="account-sign-out"
        className="flex flex-1 flex-col gap-[16px] border-t border-[rgba(22,22,22,0.13)] pt-[24px]"
      >
        <h2 id="account-sign-out" className={sectionLabel}>
          Sign out
        </h2>
        {error ? (
          <p role="alert" className={bodyText}>
            {error}
          </p>
        ) : null}
        <SweepButton
          quiet
          type="button"
          focus="ring"
          placement="start"
          disabled={pending}
          onClick={onSignOut}
        >
          {pending ? "Signing out…" : "Sign out"}
        </SweepButton>
      </section>
    </div>
  );
}
